<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Užsakymo atmetimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12">
                <el-textarea
                  required
                  label="Atmetimo priežastis"
                  tooltip="Paieška. Atmetimo priežastis"
                  :counter="1000"
                  v-model="priezastis"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button primary @click.native="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPazymaAtmetimas',
  props: {
    value: Boolean,
    paiId: Number,
    item: Object,
  },
  data() {
    return {
      loading: true,
      priezastis: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('savedData', {
            pai_id: this.paiId,
            priezastis: this.priezastis,
            item: this.item,
          })
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      //this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
